'use client';

import React, { useState, useEffect } from 'react';



interface Industry {
  id: number;
  name: string;
  icon: string;
  description: string;
  image: string;
  alt: string;
  features: string[];
  stats: {
    label: string;
    value: string;
  }[];
}

const IndustryShowcase = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [activeIndustry, setActiveIndustry] = useState(0);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const industries: Industry[] = [
  {
    id: 1,
    name: "Healthcare",
    icon: "HeartIcon",
    description: "Transform patient care with intelligent voice assistants that handle appointments, medical inquiries, and emergency routing with HIPAA compliance.",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a7cf43e4-1764670836798.png",
    alt: "Modern hospital reception desk with medical staff using digital tablets and voice technology",
    features: ["24/7 Patient Support", "Appointment Scheduling", "Medical Record Access", "Emergency Routing"],
    stats: [
    { label: "Response Time", value: "< 2 sec" },
    { label: "Patient Satisfaction", value: "96%" }]

  },
  {
    id: 2,
    name: "Finance",
    icon: "BanknotesIcon",
    description: "Secure voice banking solutions enabling account management, fraud detection, and personalized financial advice through natural conversations.",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ff08559a-1765030143856.png",
    alt: "Financial analyst reviewing data charts on multiple computer screens in modern office",
    features: ["Voice Banking", "Fraud Detection", "Account Management", "Investment Advice"],
    stats: [
    { label: "Security Level", value: "Bank-grade" },
    { label: "Transaction Speed", value: "3x Faster" }]

  },
  {
    id: 3,
    name: "Retail",
    icon: "ShoppingCartIcon",
    description: "Enhance shopping experiences with voice-powered product discovery, order tracking, and personalized recommendations that drive conversions.",
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_151bc84ba-1766082901080.png",
    alt: "Modern retail store interior with customers shopping and interactive digital displays",
    features: ["Product Discovery", "Order Tracking", "Personalized Recommendations", "Voice Commerce"],
    stats: [
    { label: "Conversion Rate", value: "+45%" },
    { label: "Cart Abandonment", value: "-32%" }]

  },
  {
    id: 4,
    name: "Automotive",
    icon: "TruckIcon",
    description: "Revolutionize in-vehicle experiences with hands-free navigation, entertainment control, and vehicle diagnostics through voice commands.",
    image: "https://images.unsplash.com/photo-1655811937685-5a58f313832a",
    alt: "Luxury car interior dashboard with advanced digital display and voice control interface",
    features: ["Hands-free Navigation", "Vehicle Diagnostics", "Entertainment Control", "Safety Alerts"],
    stats: [
    { label: "Driver Safety", value: "+40%" },
    { label: "User Adoption", value: "89%" }]

  }];


  const handleIndustryChange = (index: number) => {
    if (!isHydrated) return;
    setActiveIndustry(index);
  };

  const currentIndustry = industries[activeIndustry];

  return;
































































































};

export default IndustryShowcase;